import {
    BASE_URL, 
    POST,  
    REMINDE_ME,
  } from "../constants";
  import { statusParsing, jsonParsing } from "../utils";
  import { getAccessToken } from "../../authActions/authActions";
  
  export const remindMe = async (payload) => {
    const token = await getAccessToken();
    const resource =  `${BASE_URL}${REMINDE_ME}`;
    return fetch(resource, {
      method: POST,
      headers: {
        "Content-Type": "application/json",
        "userauth": `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    })
      .then(statusParsing)
      .then(jsonParsing);
  };
  